<template>
  <v-list-item>
    <v-list-item-title>
      <v-icon size="small"> mdi-code-parentheses-box </v-icon>
      {{ item.name }}
    </v-list-item-title></v-list-item
  >
</template>
<script setup lang="ts">
import { Slot } from "../Editor/services/simulation/simulation-control";

defineProps<{ item: Slot }>();
</script>
